<template>
  <banners>
    <div class="mx-auto max-w-screen-lg p-6 text-left">
      <p class="header-text mb-8 text-dark-blue">Account Overview</p>
      <show-profile />
    </div>
  </banners>
</template>

<script type="text/javascript">
import Banners from '@/components/Banners.vue';
import ShowProfile from '@/views/common/my-profile/ShowProfile.vue';

export default {
  name: 'CarrierWelcomePage',
  components: {
    Banners,
    ShowProfile,
  },
  created() {
    const storage = localStorage.getItem('redirect_url_after_sigin');
    if (storage) {
      let redirectAfterSignIn = JSON.parse(
        localStorage.getItem('redirect_url_after_sigin')
      );

      if (redirectAfterSignIn) {
        localStorage.removeItem('redirect_url_after_sigin');
        return this.$router.push(redirectAfterSignIn);
      }
    }
  },
};
</script>

<style scoped>
.header-text {
  font-size: 26px;
}
</style>
